import { useTranslation } from "react-i18next";
import { styled } from "styled-components";
import { CardButton } from "../../core/components/buttons/CardButton";
import { InfoText } from "../../core/components/texts/InfoText";
import { useMainStore } from "../../core/store/mainStore";
import { useHandleAppointmentBookingNavigation } from "../navigation/utils/useHandleAppointmentBookingNavigation";
import { AppointmentScreenWrapper } from "../onboarding/AppointmentScreenWrapper";
import { useNavigateToReturnUrl } from "./utils/useNavigateToReturnUrl";

// PF-5483: only Therapium chains navigate here (self-payer confirmation);
// all other chains branch on allowBookingWithoutRecipe in AppointmentRecipeInfoScreen.
export const AppointmentNoRecipeScreen = () => {
  const { t } = useTranslation();
  const navigate = useHandleAppointmentBookingNavigation();
  const { appointmentReturnUrl, navigateToReturnUrl, returnButtonText } =
    useNavigateToReturnUrl();
  const setRebookingWithoutRecipe = useMainStore(
    (state) => state.setRebookingWithoutRecipe,
  );
  const setAppointmentPatientIsSelfPayer = useMainStore(
    (state) => state.setAppointmentPatientIsSelfPayer,
  );

  const handleTherapiumSelfPayerConfirmation = () => {
    setAppointmentPatientIsSelfPayer(true);
    setRebookingWithoutRecipe(undefined);
    navigate("selfPayerDuration");
  };

  const handleTherapiumNoSelfPayer = () => {
    navigateToReturnUrl();
  };

  return (
    <AppointmentScreenWrapper hideNextButton>
      <InfoText
        headline={t("APPOINTMENT_NO_RECIPE")}
        subtitles={[
          t("APPOINTMENT_NO_RECIPE_HINT_LINE_1"),
          t("APPOINTMENT_NO_RECIPE_HINT_LINE_2"),
        ]}
      />
      <CardsContainer>
        <CardButton
          onClick={handleTherapiumSelfPayerConfirmation}
          title={t("APPOINTMENT_RECIPE_SELF_PAYER")}
        />
        {appointmentReturnUrl && (
          <CardButton
            onClick={handleTherapiumNoSelfPayer}
            title={returnButtonText}
          />
        )}
      </CardsContainer>
    </AppointmentScreenWrapper>
  );
};

const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
